// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/App.css';
import '@rainbow-me/rainbowkit/styles.css';

import {
  RainbowKitProvider,
  lightTheme, 
  connectorsForWallets,
} from '@rainbow-me/rainbowkit';

import {
  trustWallet,
  bitgetWallet,
  okxWallet,
  metaMaskWallet,
  walletConnectWallet,
  injectedWallet,
  coinbaseWallet,
  binanceWallet,
} from '@rainbow-me/rainbowkit/wallets';

import { createConfig, WagmiProvider, http } from 'wagmi';
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { supportedChains } from './utils/chainConfig';

// 1. SETUP URUTAN WALLET
const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        trustWallet,          
        bitgetWallet,         
        okxWallet,            
        metaMaskWallet,       
        walletConnectWallet,  
        injectedWallet,       
        coinbaseWallet,       
        binanceWallet,        
      ],
    },
  ],
  {
    appName: 'Espresso Claim Portal',
    // Project ID Anda sudah benar
    projectId: '9089901a43e0ece70dbd731857c697a6', 
  }
);

// --- PERBAIKAN DI SINI ---
// Kita buat object transports secara otomatis agar tidak ada Chain yang tertinggal/error
const transports = {};
supportedChains.forEach(chain => {
  transports[chain.id] = http();
});
// -------------------------

// 2. WAGMI CONFIG
const config = createConfig({
  connectors,
  chains: supportedChains,
  transports: transports, // Gunakan transports dinamis yang kita buat di atas
  ssr: false,
});

const queryClient = new QueryClient();

// 3. CUSTOM THEME (Cream #fcebde)
const customEspressoTheme = lightTheme({
  accentColor: '#270903',           
  accentColorForeground: '#fcebde', 
  borderRadius: 'medium',
  fontStack: 'system',              
  overlayBlur: 'small',
});

// Override Warna Manual
customEspressoTheme.colors.modalBackground = '#fcebde'; 
customEspressoTheme.colors.modalText = '#270903';       
customEspressoTheme.colors.modalTextSecondary = '#5c3a2e'; 
customEspressoTheme.colors.actionButtonSecondaryBackground = 'rgba(39, 9, 3, 0.05)'; 
customEspressoTheme.colors.actionButtonBorder = 'rgba(39, 9, 3, 0.1)'; 
customEspressoTheme.colors.generalBorder = 'rgba(39, 9, 3, 0.1)';      
customEspressoTheme.colors.closeButton = '#270903';     
customEspressoTheme.colors.closeButtonBackground = 'rgba(39, 9, 3, 0.05)';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider 
          theme={customEspressoTheme} 
          initialChain={supportedChains[0]} 
          modalSize="compact"
        >
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);